export interface CityInfo {
  name: string;
  lat: number;
  lon: number;
  /** 估计的 0.1m 深度年均土壤温度（°C），用于 PF 分区参考地图 */
  estTs: number;
}

export interface ProvinceInfo {
  cities: CityInfo[];
}

export const provinceCityData: Record<string, ProvinceInfo> = {
  北京: { cities: [{ name: '北京', lat: 39.9042, lon: 116.4074, estTs: 14.5 }] },
  天津: { cities: [{ name: '天津', lat: 39.1252, lon: 117.1904, estTs: 14.5 }] },
  上海: { cities: [{ name: '上海', lat: 31.2304, lon: 121.4737, estTs: 18 }] },
  重庆: { cities: [{ name: '重庆', lat: 29.563, lon: 106.5516, estTs: 20 }] },
  河北: {
    cities: [
      { name: '石家庄', lat: 38.0428, lon: 114.5149, estTs: 15 },
      { name: '唐山', lat: 39.6292, lon: 118.1802, estTs: 13.5 },
      { name: '秦皇岛', lat: 39.9354, lon: 119.5962, estTs: 12.5 },
      { name: '邯郸', lat: 36.6099, lon: 114.4905, estTs: 15 },
      { name: '保定', lat: 38.8739, lon: 115.4646, estTs: 14.5 },
      { name: '张家口', lat: 40.7676, lon: 114.8863, estTs: 9 },
      { name: '沧州', lat: 38.3037, lon: 116.8388, estTs: 14.5 },
      { name: '承德', lat: 40.9515, lon: 117.9634, estTs: 10 },
      { name: '廊坊', lat: 39.5379, lon: 116.6836, estTs: 14.5 },
      { name: '邢台', lat: 37.0708, lon: 114.5044, estTs: 15 },
      { name: '衡水', lat: 37.7389, lon: 115.6702, estTs: 15 },
    ],
  },
  山西: {
    cities: [
      { name: '太原', lat: 37.8706, lon: 112.5489, estTs: 12 },
      { name: '大同', lat: 40.0764, lon: 113.295, estTs: 8 },
      { name: '运城', lat: 35.0264, lon: 111.007, estTs: 15.5 },
      { name: '临汾', lat: 36.088, lon: 111.5189, estTs: 13.5 },
      { name: '长治', lat: 36.1954, lon: 113.1163, estTs: 12 },
      { name: '晋城', lat: 35.4907, lon: 112.8518, estTs: 13.5 },
      { name: '阳泉', lat: 37.8567, lon: 113.5802, estTs: 12 },
    ],
  },
  内蒙古: {
    cities: [
      { name: '呼和浩特', lat: 40.8414, lon: 111.7519, estTs: 8 },
      { name: '包头', lat: 40.6582, lon: 109.8404, estTs: 8.5 },
      { name: '赤峰', lat: 42.2578, lon: 118.8869, estTs: 8 },
      { name: '鄂尔多斯', lat: 39.6083, lon: 109.7807, estTs: 8 },
      { name: '呼伦贝尔', lat: 49.2117, lon: 119.7658, estTs: 2.5 },
      { name: '通辽', lat: 43.6177, lon: 122.2431, estTs: 7 },
      { name: '乌海', lat: 39.6538, lon: 106.7954, estTs: 10 },
    ],
  },
  辽宁: {
    cities: [
      { name: '沈阳', lat: 41.8057, lon: 123.4315, estTs: 10 },
      { name: '大连', lat: 38.914, lon: 121.6147, estTs: 12.5 },
      { name: '鞍山', lat: 41.1085, lon: 122.9946, estTs: 10.5 },
      { name: '抚顺', lat: 41.8809, lon: 123.9572, estTs: 8.5 },
      { name: '锦州', lat: 41.0951, lon: 121.1272, estTs: 11 },
      { name: '丹东', lat: 40.129, lon: 124.3875, estTs: 10.5 },
      { name: '营口', lat: 40.6675, lon: 122.2358, estTs: 11.5 },
    ],
  },
  吉林: {
    cities: [
      { name: '长春', lat: 43.8171, lon: 125.3235, estTs: 7.5 },
      { name: '吉林', lat: 43.8378, lon: 126.5494, estTs: 7 },
      { name: '四平', lat: 43.1664, lon: 124.3504, estTs: 8 },
      { name: '延吉', lat: 42.9063, lon: 129.5089, estTs: 6.5 },
      { name: '通化', lat: 41.7289, lon: 125.9398, estTs: 8 },
      { name: '松原', lat: 45.1411, lon: 124.8253, estTs: 7 },
    ],
  },
  黑龙江: {
    cities: [
      { name: '哈尔滨', lat: 45.8038, lon: 126.535, estTs: 6 },
      { name: '齐齐哈尔', lat: 47.3543, lon: 123.9179, estTs: 4.5 },
      { name: '大庆', lat: 46.5893, lon: 125.1036, estTs: 5.5 },
      { name: '牡丹江', lat: 44.5525, lon: 129.6321, estTs: 5.5 },
      { name: '佳木斯', lat: 46.7997, lon: 130.3265, estTs: 4.5 },
      { name: '黑河', lat: 50.2441, lon: 127.5289, estTs: 2 },
    ],
  },
  江苏: {
    cities: [
      { name: '南京', lat: 32.0603, lon: 118.7969, estTs: 17 },
      { name: '苏州', lat: 31.299, lon: 120.5853, estTs: 18 },
      { name: '无锡', lat: 31.4912, lon: 120.3119, estTs: 18 },
      { name: '徐州', lat: 34.2058, lon: 117.2841, estTs: 16 },
      { name: '常州', lat: 31.8107, lon: 119.974, estTs: 18 },
      { name: '南通', lat: 31.9805, lon: 120.8943, estTs: 17.5 },
      { name: '扬州', lat: 32.3942, lon: 119.4129, estTs: 17 },
      { name: '镇江', lat: 32.1878, lon: 119.4258, estTs: 17 },
      { name: '盐城', lat: 33.3476, lon: 120.1636, estTs: 16.5 },
      { name: '连云港', lat: 34.5966, lon: 119.2211, estTs: 16 },
      { name: '淮安', lat: 33.6103, lon: 119.0212, estTs: 16.5 },
    ],
  },
  浙江: {
    cities: [
      { name: '杭州', lat: 30.2741, lon: 120.1551, estTs: 18.5 },
      { name: '宁波', lat: 29.8683, lon: 121.544, estTs: 18.5 },
      { name: '温州', lat: 28.0008, lon: 120.7019, estTs: 20 },
      { name: '嘉兴', lat: 30.7461, lon: 120.7555, estTs: 18 },
      { name: '绍兴', lat: 30.0303, lon: 120.5802, estTs: 18.5 },
      { name: '金华', lat: 29.0792, lon: 119.6474, estTs: 19 },
      { name: '台州', lat: 28.6568, lon: 121.4208, estTs: 19.5 },
      { name: '湖州', lat: 30.8937, lon: 120.0852, estTs: 18 },
    ],
  },
  安徽: {
    cities: [
      { name: '合肥', lat: 31.8206, lon: 117.2272, estTs: 17.5 },
      { name: '芜湖', lat: 31.3341, lon: 118.3723, estTs: 18 },
      { name: '蚌埠', lat: 32.9176, lon: 117.3893, estTs: 17 },
      { name: '安庆', lat: 30.5318, lon: 117.0587, estTs: 17.5 },
      { name: '阜阳', lat: 32.8896, lon: 115.8149, estTs: 16.5 },
      { name: '黄山', lat: 29.7147, lon: 118.3375, estTs: 17.5 },
    ],
  },
  福建: {
    cities: [
      { name: '福州', lat: 26.0745, lon: 119.2965, estTs: 21 },
      { name: '厦门', lat: 24.4798, lon: 118.0894, estTs: 22.5 },
      { name: '泉州', lat: 24.9139, lon: 118.6757, estTs: 22 },
      { name: '漳州', lat: 24.5133, lon: 117.6474, estTs: 22.5 },
      { name: '莆田', lat: 25.454, lon: 119.0077, estTs: 21.5 },
      { name: '龙岩', lat: 25.0913, lon: 117.0172, estTs: 20.5 },
    ],
  },
  江西: {
    cities: [
      { name: '南昌', lat: 28.682, lon: 115.8579, estTs: 19 },
      { name: '赣州', lat: 25.8317, lon: 114.9326, estTs: 20 },
      { name: '九江', lat: 29.7051, lon: 116.0015, estTs: 18.5 },
      { name: '上饶', lat: 28.4547, lon: 117.9433, estTs: 18.5 },
      { name: '宜春', lat: 27.8144, lon: 114.4168, estTs: 19 },
      { name: '吉安', lat: 27.0874, lon: 114.9925, estTs: 19.5 },
    ],
  },
  山东: {
    cities: [
      { name: '济南', lat: 36.6512, lon: 117.1201, estTs: 16 },
      { name: '青岛', lat: 36.0671, lon: 120.3826, estTs: 15 },
      { name: '烟台', lat: 37.4638, lon: 121.4481, estTs: 14.5 },
      { name: '潍坊', lat: 36.7089, lon: 119.1619, estTs: 15.5 },
      { name: '临沂', lat: 35.1037, lon: 118.3567, estTs: 15.5 },
      { name: '淄博', lat: 36.8135, lon: 118.0548, estTs: 16 },
      { name: '济宁', lat: 35.4148, lon: 116.5875, estTs: 16 },
      { name: '威海', lat: 37.5135, lon: 122.1206, estTs: 14 },
    ],
  },
  河南: {
    cities: [
      { name: '郑州', lat: 34.7466, lon: 113.6254, estTs: 16.5 },
      { name: '洛阳', lat: 34.6183, lon: 112.454, estTs: 16 },
      { name: '开封', lat: 34.7972, lon: 114.3077, estTs: 16.5 },
      { name: '新乡', lat: 35.303, lon: 113.9268, estTs: 16 },
      { name: '南阳', lat: 32.9908, lon: 112.5283, estTs: 16.5 },
      { name: '信阳', lat: 32.1471, lon: 114.0918, estTs: 17 },
      { name: '安阳', lat: 36.0977, lon: 114.3929, estTs: 15.5 },
      { name: '商丘', lat: 34.4145, lon: 115.6565, estTs: 16 },
    ],
  },
  湖北: {
    cities: [
      { name: '武汉', lat: 30.5928, lon: 114.3055, estTs: 19 },
      { name: '宜昌', lat: 30.6919, lon: 111.2865, estTs: 18.5 },
      { name: '襄阳', lat: 32.009, lon: 112.1225, estTs: 17 },
      { name: '荆州', lat: 30.3357, lon: 112.2398, estTs: 18 },
      { name: '黄石', lat: 30.2004, lon: 115.0383, estTs: 19 },
      { name: '十堰', lat: 32.6292, lon: 110.7977, estTs: 17 },
    ],
  },
  湖南: {
    cities: [
      { name: '长沙', lat: 28.2282, lon: 112.9388, estTs: 19 },
      { name: '株洲', lat: 27.8274, lon: 113.1339, estTs: 19 },
      { name: '湘潭', lat: 27.8297, lon: 112.9442, estTs: 19 },
      { name: '衡阳', lat: 26.8932, lon: 112.5719, estTs: 19.5 },
      { name: '岳阳', lat: 29.3571, lon: 113.1288, estTs: 18.5 },
      { name: '常德', lat: 29.0318, lon: 111.6992, estTs: 18.5 },
      { name: '郴州', lat: 25.7706, lon: 113.0148, estTs: 19.5 },
    ],
  },
  广东: {
    cities: [
      { name: '广州', lat: 23.1291, lon: 113.2644, estTs: 23.5 },
      { name: '深圳', lat: 22.5431, lon: 114.0579, estTs: 24 },
      { name: '珠海', lat: 22.2707, lon: 113.5671, estTs: 24 },
      { name: '佛山', lat: 23.0218, lon: 113.1219, estTs: 23.5 },
      { name: '东莞', lat: 23.0469, lon: 113.7633, estTs: 24 },
      { name: '中山', lat: 22.5176, lon: 113.3928, estTs: 24 },
      { name: '惠州', lat: 23.1115, lon: 114.4162, estTs: 23.5 },
      { name: '江门', lat: 22.5787, lon: 113.0816, estTs: 23.5 },
      { name: '汕头', lat: 23.3545, lon: 116.6822, estTs: 23 },
      { name: '湛江', lat: 21.2707, lon: 110.3594, estTs: 24.5 },
      { name: '韶关', lat: 24.8104, lon: 113.5976, estTs: 21.5 },
    ],
  },
  广西: {
    cities: [
      { name: '南宁', lat: 22.817, lon: 108.3665, estTs: 23 },
      { name: '桂林', lat: 25.274, lon: 110.2993, estTs: 20.5 },
      { name: '柳州', lat: 24.3255, lon: 109.4154, estTs: 21.5 },
      { name: '北海', lat: 21.4812, lon: 109.1197, estTs: 24 },
      { name: '玉林', lat: 22.6515, lon: 110.1809, estTs: 22.5 },
      { name: '梧州', lat: 23.4769, lon: 111.2791, estTs: 22 },
    ],
  },
  海南: {
    cities: [
      { name: '海口', lat: 20.044, lon: 110.1999, estTs: 26 },
      { name: '三亚', lat: 18.2528, lon: 109.5121, estTs: 27 },
      { name: '儋州', lat: 19.5211, lon: 109.5808, estTs: 26 },
      { name: '琼海', lat: 19.2583, lon: 110.4746, estTs: 26.5 },
    ],
  },
  四川: {
    cities: [
      { name: '成都', lat: 30.5728, lon: 104.0668, estTs: 18 },
      { name: '绵阳', lat: 31.4681, lon: 104.6796, estTs: 18 },
      { name: '德阳', lat: 31.1268, lon: 104.3979, estTs: 18 },
      { name: '南充', lat: 30.8375, lon: 106.1107, estTs: 18.5 },
      { name: '宜宾', lat: 28.7518, lon: 104.6418, estTs: 19 },
      { name: '泸州', lat: 28.8717, lon: 105.4423, estTs: 19 },
      { name: '攀枝花', lat: 26.5822, lon: 101.7183, estTs: 22 },
      { name: '乐山', lat: 29.5521, lon: 103.7656, estTs: 18.5 },
      { name: '西昌', lat: 27.8944, lon: 102.2645, estTs: 19 },
    ],
  },
  贵州: {
    cities: [
      { name: '贵阳', lat: 26.647, lon: 106.6302, estTs: 16.5 },
      { name: '遵义', lat: 27.7254, lon: 106.9274, estTs: 17 },
      { name: '六盘水', lat: 26.5943, lon: 104.8307, estTs: 15 },
      { name: '安顺', lat: 26.2456, lon: 105.9473, estTs: 16.5 },
      { name: '毕节', lat: 27.2984, lon: 105.2836, estTs: 15.5 },
    ],
  },
  云南: {
    cities: [
      { name: '昆明', lat: 25.0389, lon: 102.7183, estTs: 16.5 },
      { name: '大理', lat: 25.6065, lon: 100.2676, estTs: 16 },
      { name: '丽江', lat: 26.855, lon: 100.2272, estTs: 14.5 },
      { name: '曲靖', lat: 25.4901, lon: 103.7961, estTs: 16 },
      { name: '玉溪', lat: 24.3473, lon: 102.5279, estTs: 17.5 },
      { name: '西双版纳', lat: 22.0087, lon: 100.7963, estTs: 22.5 },
      { name: '红河', lat: 23.367, lon: 103.3734, estTs: 19 },
    ],
  },
  西藏: {
    cities: [
      { name: '拉萨', lat: 29.6501, lon: 91.1018, estTs: 9.5 },
      { name: '日喀则', lat: 29.2669, lon: 88.8814, estTs: 8 },
      { name: '昌都', lat: 31.1392, lon: 97.1792, estTs: 8.5 },
      { name: '林芝', lat: 29.6488, lon: 94.362, estTs: 10.5 },
    ],
  },
  陕西: {
    cities: [
      { name: '西安', lat: 34.3416, lon: 108.9398, estTs: 15.5 },
      { name: '咸阳', lat: 34.3296, lon: 108.7089, estTs: 15.5 },
      { name: '宝鸡', lat: 34.3619, lon: 107.2377, estTs: 14.5 },
      { name: '汉中', lat: 33.0678, lon: 107.0237, estTs: 16.5 },
      { name: '延安', lat: 36.5855, lon: 109.4897, estTs: 11.5 },
      { name: '榆林', lat: 38.2853, lon: 109.7344, estTs: 10.5 },
    ],
  },
  甘肃: {
    cities: [
      { name: '兰州', lat: 36.0611, lon: 103.8343, estTs: 11 },
      { name: '天水', lat: 34.5809, lon: 105.7249, estTs: 13 },
      { name: '酒泉', lat: 39.7328, lon: 98.4944, estTs: 8 },
      { name: '张掖', lat: 38.9259, lon: 100.4499, estTs: 8.5 },
      { name: '武威', lat: 37.9283, lon: 102.6378, estTs: 9.5 },
      { name: '平凉', lat: 35.5428, lon: 106.6647, estTs: 11.5 },
    ],
  },
  青海: {
    cities: [
      { name: '西宁', lat: 36.6171, lon: 101.7782, estTs: 7.5 },
      { name: '格尔木', lat: 36.4064, lon: 94.9037, estTs: 6.5 },
      { name: '海东', lat: 36.5026, lon: 102.1043, estTs: 7.5 },
    ],
  },
  宁夏: {
    cities: [
      { name: '银川', lat: 38.4872, lon: 106.2309, estTs: 11 },
      { name: '石嘴山', lat: 39.016, lon: 106.3768, estTs: 10.5 },
      { name: '吴忠', lat: 37.9847, lon: 106.1983, estTs: 11 },
      { name: '固原', lat: 36.0159, lon: 106.2421, estTs: 9 },
    ],
  },
  新疆: {
    cities: [
      { name: '乌鲁木齐', lat: 43.8256, lon: 87.6168, estTs: 8.5 },
      { name: '克拉玛依', lat: 45.5792, lon: 84.8892, estTs: 9 },
      { name: '喀什', lat: 39.4704, lon: 75.9896, estTs: 13.5 },
      { name: '吐鲁番', lat: 42.9513, lon: 89.1895, estTs: 16 },
      { name: '伊宁', lat: 43.9184, lon: 81.2746, estTs: 10 },
      { name: '阿克苏', lat: 41.1689, lon: 80.2601, estTs: 12 },
      { name: '库尔勒', lat: 41.7294, lon: 86.1746, estTs: 13 },
    ],
  },
  香港: { cities: [{ name: '香港', lat: 22.3193, lon: 114.1694, estTs: 24 }] },
  澳门: { cities: [{ name: '澳门', lat: 22.1987, lon: 113.5439, estTs: 24 }] },
  台湾: {
    cities: [
      { name: '台北', lat: 25.033, lon: 121.5654, estTs: 23 },
      { name: '高雄', lat: 22.6273, lon: 120.3014, estTs: 25 },
      { name: '台中', lat: 24.1477, lon: 120.6736, estTs: 24 },
      { name: '台南', lat: 22.9999, lon: 120.227, estTs: 25 },
    ],
  },
};

export const provinceList = Object.keys(provinceCityData);

export const soilLayers = [
  { value: '1', label: 'Layer 1 — 0.018–0.099 m' },
  { value: '2', label: 'Layer 2 — 0.099–0.294 m（默认，近耕层）' },
  { value: '3', label: 'Layer 3 — 0.294–0.680 m' },
  { value: '4', label: 'Layer 4 — 0.680–1.443 m' },
  { value: '5', label: 'Layer 5 — 1.443–2.949 m' },
  { value: '6', label: 'Layer 6 — 2.949–10.0 m' },
];